import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { Button } from "./ui/button";
import { Settings } from "lucide-react";

export const CookiePreferencesButton = () => {
  const { openModal, consent } = useCookieConsent();

  // Only show after user has made a choice
  if (!consent) return null;

  return (
    <Button
      onClick={openModal}
      variant="secondary"
      size="sm"
      className="fixed bottom-4 left-4 z-40 backdrop-blur-lg bg-background/90 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 gap-2"
      aria-label="Apri preferenze cookie"
    >
      <Settings className="h-4 w-4" />
      <span className="hidden sm:inline">Preferenze cookie</span>
    </Button>
  );
};
